import { render, staticRenderFns } from "./FormRecipientsPage.vue?vue&type=template&id=44d454e6&scoped=true&"
import script from "./FormRecipientsPage.vue?vue&type=script&lang=js&"
export * from "./FormRecipientsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d454e6",
  null
  
)

export default component.exports